export const de = {
    consent: {
        titulo: "Cookie-Einwilligung",
        texto: "Wir verwenden Cookies, um Besuche zu messen und die Kommunikation rund um den Anlass zu verbessern. Die Marketing-Messung wird nur mit deiner Einwilligung aktiviert.",
        aceitar: "Akzeptieren",
        rejeitar: "Nur essenzielle",
        saberMais: "Mehr erfahren",
    },
    nav: {
        experiencia: "Erlebnis",
        noiteFados: "Fado-Nacht",
        equipa: "Team",
        artistas: "Künstler",
        noticias: "Nachrichten",
        missao: "Mission",
        associacao: "Der Verein",
        vantagens: "Mitgliedervorteile",
        contacto: "Kontakt",
        reservar: "Reservieren",
        local: "Anfahrt",
    },
    hero: {
        headlineTop: "EIN ABEND\nGEWIDMET DEM",
        headlineAdj: "PORTUGIESISCHEN",
        headlineItalico: "Ein portugiesischer Abend.\nAm Tisch.\nLive.",
        quando: "Wann",
        data: "14. November 2026",
        hora: "ab 17:00 Uhr",
        onde: "Wo",
        local: "Centro Papa Giovanni",
        morada: "Hübelistrasse 55, Emmenbrücke",
        comprar: "Tickets kaufen",
        urgencia: "Exklusives Event · Begrenzte Plätze",
        saibaMais: "Mehr erfahren",
        countdown: {
            label: "Early-Bird-Preis endet in",
            dias: "Tage",
            horas: "Std",
            min: "Min",
            seg: "Sek",
        },
    },
    pillars: [
        { id: "fado-ao-vivo", title: "Live-Fado", text: "Die Emotion des Fado, Portugals immaterielles Kulturerbe." },
        { id: "gastronomia", title: "Portugiesische Gastronomie", text: "Traditionelle Aromen in einem Abendessen, das mit Exzellenz zubereitet wird." },
        { id: "vinhos", title: "Portugiesische Weine", text: "Eine Auswahl von Weinen aus den besten Regionen Portugals." },
        { id: "cultura", title: "Kultur & Tradition", text: "Eine Feier unserer Identität, Geschichte und Gastfreundschaft." },
        { id: "ambiente", title: "Exklusive Atmosphäre", text: "Ein intimer Raum für ein unvergessliches Erlebnis." },
    ],
    watermark: "Visuelles Beispiel",
    influencer: {
        label: "Offizieller Influencer",
        nome: "Nelson Jackson",
        titulo: "Die Stimme, die Fados à Mesa in die Gemeinschaft trägt",
        texto: "Nelson Jackson ist der offizielle Influencer von Fados à Mesa. Mit der Flagge um die Schultern und seiner gewohnten Energie begleitet er mit uns den Countdown zur Nacht des 14. November – mit Blicken hinter die Kulissen, Neuigkeiten und Überraschungen in den sozialen Medien.",
        legenda: "Nelson Jacksons Botschaft an die portugiesische Gemeinschaft",
        play: "Video ansehen",
    },
    convidadoHonra: {
        label: "Ehrengast",
        confirmado: "Teilnahme bestätigt",
        bemVindo: "Herzlich willkommen, Exzellenz!",
        excelencia: "Seine Exzellenz",
        nome: "Dr. Gonçalo Motta",
        cargo: "Generalkonsul von Portugal in Zürich",
        citacao: "Kultur bringt uns näher. Portugal lebt in jedem von uns.",
        texto: "Mit grosser Ehre empfangen wir Seine Exzellenz Dr. Gonçalo Motta, Generalkonsul von Portugal in Zürich, als unseren Ehrengast bei Fados à Mesa. Die Anwesenheit der diplomatischen Vertretung Portugals ist eine Anerkennung des Wertes der portugiesischen Kultur und der Bedeutung, unsere Traditionen lebendig zu halten – und die Gemeinschaft rund um Musik, Gastronomie und unsere Identität zu vereinen.",
        sobreTitulo: "Über Dr. Gonçalo Motta",
        sobre: "Dr. Gonçalo Motta ist der amtierende Generalkonsul von Portugal in Zürich und vertritt das portugiesische Aussenministerium. Ausgebildet an der Universidade Lusíada in Lissabon und mit langjähriger diplomatischer Erfahrung widmet er sich der Stärkung der Beziehungen zwischen Portugal und der Schweiz, der Unterstützung der portugiesischen Gemeinschaften und der Förderung der Kultur und des Bildes Portugals im Ausland.",
        verCartaz: "Offizielles Plakat ansehen",
    },
    patrocinadores: {
        titulo: "OFFIZIELLE SPONSOREN",
        maisA: "Und weitere",
        maisB: "Sponsoren",
        agradecimentos: {
            famosa: "Unser tiefster Dank an die Pastelaria Famosa, unsere exklusive Sponsorin, für das Vertrauen und die Süsse, mit der sie diesen Abend vom ersten Tag an begleitet.",
            srVinho: "Danke an Sr. Vinho, das typisch portugiesische Restaurant, das unsere Mitglieder mit 10% Rabatt und einem Digestif empfängt.",
            cr7Helder: "Unser herzlicher Dank an CR7 Helder – für das Vertrauen in den Fado und die stilvolle Fahrt zu diesem Abend.",
            saboresPortugal: "Unser herzlicher Dank an Sabores de Portugal – für das Beste unserer Gastronomie auf dem Tisch und einen Abend mit dem echten Geschmack Portugals.",
            wildenMann: "Danke an das Hotel Wilden Mann – fünf Jahrhunderte Luzerner Gastfreundschaft an der Seite des Fado.",
            barniPost: "Danke an die Barni-Post, die den Fado in jedes Haus der Zentralschweiz bringt.",
            superBock: "Danke an die Super Bock Group, die das portugiesischste aller Biere auf den Tisch bringt.",
            clubPortugues: "Danke an den Club Português Luzern – seit so vielen Jahren das Zuhause unserer Gemeinschaft.",
            casaBenfica: "Danke an die Casa Benfica Zurique für die Leidenschaft, die Portugiesen in der ganzen Schweiz verbindet.",
            immoHaus: "Danke an ImmoHaus Portugal, das so vielen Familien ein Zuhause findet – und uns das seine öffnet.",
        },
    },
    artistas: { titulo: "UNSERE KÜNSTLER" },
    parceiros: { titulo: "INSTITUTIONELLE PARTNER" },
    localizacao: {
        saberMais: "Mehr erfahren",
        label: "Wo die Veranstaltung stattfindet",
        titulo: "ANREISE",
        intro: "Die Veranstaltung findet in Emmenbrücke statt, erreichbar mit öffentlichen Verkehrsmitteln, dem Auto oder dem Fahrrad. Nachfolgend die praktischen Anreiseinformationen.",
        moradaLabel: "Adresse",
        moradaValor: "Centro Papa Giovanni, Hübelistrasse 55, 6020 Emmenbrücke, Schweiz",
        gpsLabel: "GPS-Koordinaten",
        gpsValor: "47.0706° N, 8.2849° O",
        acessosTitulo: "Anfahrt",
        transportesTitulo: "Öffentliche Verkehrsmittel",
        transportes: "Bahnhof Emmenbrücke Gersag ca. 10 Gehminuten entfernt (Regionalzüge und Busse 41, 42, 43 und 44). Ab Luzern VBL-Linie 2; für die Rückfahrt Nachtbus N2.",
        carroTitulo: "Auto",
        carro: "5 Minuten von der Autobahn A2 (Ausfahrt Emmen Nord).",
        bicicletaTitulo: "Fahrrad",
        bicicleta: "Fahrradparkplätze vor Ort vorhanden.",
        estacionamentoTitulo: "Kostenlose Parkplätze",
        estacionamento: "Kostenloser Häger-Parkplatz direkt gegenüber — nur mit «Häger» gekennzeichnete Plätze, je nach Verfügbarkeit. Weitere Parkplätze in der Nähe, kostenlos und kostenpflichtig.",
        regrasTitulo: "Hausregeln des Centro Papa Giovanni",
        regras: [
            "Die Mitnahme und der Aufenthalt von Haustieren sind nicht gestattet.",
            "Im gesamten Innenbereich des Gebäudes herrscht Rauchverbot.",
        ],
    },
    cta: {
        comprar: "Tickets kaufen",
        urgencia: "Exklusives Event · Begrenzte Plätze",
        titulo: "RESERVIEREN SIE JETZT IHREN PLATZ.",
        subtitulo: "Ein Abend. Ein Tisch. Ein Fado.",
    },
    culturaNoticias: {
        noticias: "AKTUELLE NACHRICHTEN",
        nota: "Beispiel-Nachrichten — Neuigkeiten zum Event erscheinen hier.",
        news: [
            { title: "Fados à Mesa lanciert die erste Ausgabe am 14. November 2026", date: "15. MAI 2025" },
            { title: "Lernen Sie die Künstler kennen, die den Fado auf der Bühne lebendig machen", date: "10. MAI 2025" },
            { title: "Aromen Portugals: das Abendessen, das unsere Tradition feiert", date: "05. MAI 2025" },
        ],
    },
    footer: {
        frase: "Ein portugiesischer Abend, ganz bestimmt.",
        copyright: "© 2026 Fados à Mesa – Alle Rechte vorbehalten.",
        sede: "Verein Fados à Mesa · UID CHE-306.330.271 · Gerliswilstrasse 46, 6020 Emmenbrücke, Schweiz",
        privacy: "Datenschutzerklärung",
        terms: "AGB",
        colunas: [
            {
                title: "Fado-Nacht",
                links: [
                    { label: "Menü des Abends", to: "/experiencia?tab=menu" },
                    { label: "Kultur & Tradition", to: "/experiencia?tab=cultura" },
                    { label: "Gastronomie & Weine", to: "/experiencia?tab=gastro" },
                    { label: "Bar", to: "/experiencia?tab=bar" },
                    { label: "Team", to: "/equipa", ate1aEdicao: true },
                ],
            },
            {
                title: "Künstler",
                links: [
                    { label: "Künstler", to: "/#artistas" },
                    { label: "Nachrichten", to: "/noticias" },
                ],
            },
            {
                title: "Der Verein",
                links: [
                    { label: "Mission", to: "/missao" },
                    { label: "Mitgliedervorteile", to: "/socios/vantagens" },
                    { label: "Mitglied werden", to: "/associacao#adesao" },
                    { label: "Sponsoren", to: "/patrocinadores" },
                ],
            },
            {
                title: "Tickets",
                links: [
                    { label: "Tickets kaufen", to: "/bilhetes" },
                    { label: "Teilnahme bestätigen", to: "/confirmar" },
                ],
            },
            {
                title: "Kontakt",
                links: [
                    { label: "Kontakt aufnehmen", to: "/contacto" },
                    { label: "Anfahrt", to: "/local" },
                    { label: "Mediencenter", to: "/recursos" },
                ],
            },
        ],
    },
    subpage: { voltar: "Zurück" },
    audio: { tocar: "Musik abspielen", pausar: "Musik pausieren" },
    bc: {
        home: "Startseite",
        experiencia: "Erlebnis",
        equipa: "Team",
        artistas: "Künstler",
        noticias: "Nachrichten",
        missao: "Mission",
        contacto: "Kontakt",
        local: "Anfahrt",
        confirmar: "Bestätigung",
        bilhetes: "Ticketshop",
        privacidade: "Datenschutzerklärung",
        termos: "AGB",
        recursos: "Mediencenter",
        patrocinadores: "Sponsoren",
    },
    seo: {
        keywords: "Fado, Fados à Mesa, portugiesische Kultur, portugiesische Gastronomie, portugiesische Weine, portugiesisches Event Schweiz, Fado Luzern, Emmenbrücke, Dinner-Show, Ticket Corner",
        home: { title: "Fados à Mesa — Fado, Gastronomie und portugiesische Weine in der Schweiz", desc: "Dinner-Spektakel mit live Fado, portugiesischer Gastronomie und Weinen. 14. November 2026, Centro Papa Giovanni, Emmenbrücke. Jetzt Ticket sichern." },
        experiencia: { title: "Das Erlebnis — Menü, Line-up und Fado-Etikette | Fados à Mesa", desc: "Entdecken Sie das offizielle Menü, das Line-up des Abends und die Etikette des Fado: ein portugiesischer Abend, am Tisch serviert." },
        equipa: { title: "Unser Team — Produktion und Staff | Fados à Mesa", desc: "Lernen Sie das Team kennen, das den Abend möglich macht: Produktion, Küche und Service der 1. Ausgabe von Fados à Mesa." },
        missao: { title: "Die Mission — Portugiesische Kultur in der Schweiz | Fados à Mesa", desc: "Die portugiesische Kultur in die Schweiz bringen — ein Abend, ein Tisch und eine Gitarre nach der anderen." },
        contacto: { title: "Kontakt — Schreiben Sie uns | Fados à Mesa", desc: "Kontakt zur Veranstaltung Fados à Mesa: Gruppenreservierungen, Partnerschaften und Sponsoring, Presse und Fragen zur 1. Ausgabe." },
        local: { title: "Anfahrt — Centro Papa Giovanni, Emmenbrücke | Fados à Mesa", desc: "So erreichen Sie das Centro Papa Giovanni (Hübelistrasse 55, Emmenbrücke): öffentliche Verkehrsmittel, Auto, Uber und Fahrrad. Gratis Parkplätze." },
        noticias: { title: "Nachrichten — Fado, portugiesische Kultur und Neuigkeiten | Fados à Mesa", desc: "Offizielle Ankündigungen von Fados à Mesa und ausgewählte Nachrichten über unsere Künstler: Rafael Pacheco, Ginestal Martins, Cátia Garcia, Daniel Pinto Coelho und Madalena Gil." },
        confirmar: { title: "Teilnahme bestätigen — Hauptgang wählen | Fados à Mesa", desc: "Bestätigen Sie Ihre Teilnahme an Fados à Mesa und wählen Sie Ihren Hauptgang (Fisch oder Fleisch) bis zum 1. November 2026." },
        bilhetes: { title: "Offizieller Ticketshop — Tickets kaufen | Fados à Mesa", desc: "Kaufen Sie Ihr Ticket für Fados à Mesa im offiziellen Ticketshop (Eventim / Ticket Corner). Exklusives Event, begrenzte Plätze. 14.11.2026, Emmenbrücke." },
        privacidade: { title: "Datenschutzerklärung | Fados à Mesa", desc: "Datenschutzerklärung von Fados à Mesa — Bearbeitung personenbezogener Daten gemäss Schweizer Gesetz (nDSG)." },
        associacao: { title: "Der Verein | Fados à Mesa", desc: "Der Verein Fados à Mesa: wer wir sind, institutionelle Angaben, Vorstand, Partner, Beiträge, Beitrittsgesuch und Statuten." },
        termos: { title: "Allgemeine Geschäftsbedingungen | Fados à Mesa", desc: "Allgemeine Geschäftsbedingungen der Website und der Veranstaltung Fados à Mesa." },
        recursos: { title: "Mediencenter — Presse und Partner | Fados à Mesa", desc: "Offizielle Materialien von Fados à Mesa für Presse und Partner: Project Book, Press Kit, Logos und Abendprogramm." },
        patrocinadores: { title: "Offizielle Sponsoren | Fados à Mesa", desc: "Die offiziellen Partner von Fados à Mesa — ein portugiesischer Abend in der Schweiz." },
    },
    assoc: {
        titulo: "DER VEREIN",
        intro: "Ein gemeinnütziger, politisch neutraler und konfessionell unabhängiger Verein, gegründet in Emmen am 25. September 2026.",
        subnav: { quemSomos: "Wer wir sind", dados: "Angaben", direcao: "Vorstand", parceiros: "Partner", quotas: "Beiträge", adesao: "Beitritt", estatutos: "Statuten" },
        quemSomos: {
            titulo: "WER WIR SIND",
            p1: "Der Verein Fados à Mesa ist ein gemeinnütziger, politisch neutraler und konfessionell unabhängiger Verein mit Sitz in Emmen, Kanton Luzern. Er bezweckt die Förderung, Bewahrung und Verbreitung der portugiesischen und lusofonen Kultur in der Schweiz, insbesondere des Fado, der Musik, der Gastronomie, der Sprache und der portugiesischen Traditionen.",
            p2: "Dazu organisieren wir kulturelle, musikalische, gastronomische, bildungsbezogene und soziale Veranstaltungen; unser Hauptprojekt ist die Veranstaltung «Fados à Mesa». Wir fördern den kulturellen Austausch zwischen der lusofonen Gemeinschaft und der Schweizer Bevölkerung, unterstützen Künstlerinnen, Künstler und Kreative portugiesischen Ausdrucks und arbeiten mit Gemeinden, Kantonen, Stiftungen, Unternehmen, Kulturinstitutionen und anderen Vereinen zusammen.",
            p3: "Unsere Tätigkeiten stehen der allgemeinen Öffentlichkeit offen. Der Verein verfolgt keine Erwerbszwecke: allfällige Überschüsse werden vollumfänglich den statutarischen Zwecken zugeführt und niemals an die Mitglieder verteilt.",
        },
        dados: {
            titulo: "INSTITUTIONELLE ANGABEN",
            denominacao: "Bezeichnung", formaJuridica: "Rechtsform", sede: "Sitz", morada: "Adresse",
            constituicao: "Gründungsdatum", duracao: "Dauer", uid: "UID-Nummer", conta: "Bankkonto",
            exercicio: "Geschäftsjahr", contacto: "Kontakt",
            denominacaoV: "Associação Fados à Mesa (Verein Fados à Mesa)",
            formaJuridicaV: "Gemeinnütziger Verein, Art. 60 ff. ZGB",
            sedeV: "Gemeinde Emmen, Kanton Luzern, Schweiz",
            moradaV: "Gerliswilstrasse 46, 6020 Emmenbrücke",
            constituicaoV: "25.09.2026 (Gründungsversammlung, Protokoll Nr. 1)",
            duracaoV: "Unbestimmt",
            emTratamento: "In Bearbeitung", aDesignar: "Noch zu bestimmen",
            exercicioV: "Kalenderjahr",
        },
        direcao: {
            titulo: "VORSTAND UND GRÜNDUNGSMITGLIEDER",
            comite: "Vorstand", mandato: "Amtszeit 2026–2028",
            fundadores: "Gründungsmitglieder mit Funktionen an den Veranstaltungstagen",
            nota: "Die Präsidentin, die Vizepräsidentin, die Logistikleiterin und der technische Leiter sind die vier Gründungsmitglieder des Vereins.",
            paulaAngelinoNota: "Übernimmt zudem die künstlerische Leitung, das Marketing, das Design und die Kommunikation.",
            cristinaNota: "Übernimmt bei Verhinderung der Präsidentin sämtliche Exekutivbefugnisse.",
            paulaSilvaNota: "Leitung der Logistik und der Teams an den Veranstaltungstagen.",
            pauloNota: "Technische Koordination der Veranstaltungen.",
            cargoPaulaAngelino: "Präsidentin und Geschäftsführerin",
            cargoCristina: "Vizepräsidentin",
            cargoPaulaSilva: "Gründungsmitglied und Logistikleiterin",
            cargoPaulo: "Gründungsmitglied und technischer Leiter",
        },
        parceiros: {
            titulo: "PARTNER UND SPONSOREN",
            intro: "Institutionen und Partner, die sich uns angeschlossen haben, um der portugiesischen Kultur in der Schweiz eine Stimme zu geben. Kultur entsteht auch in Partnerschaft.",
            institucional: "Institutioneller Partner",
            patrocinadores: "Sponsoren",
            parceiroInstitucional: "Institutioneller Partner",
            celimar: "Exklusivpartner für Beratung und Versicherungen",
            ptPrint: "Partnerdruckerei",
            barniPost: "Medienpartner · Ausgabe vom 21. Oktober 2026",
            tiers: { exclusiva: "Exklusive Sponsorin", oficial: "Offizieller Partner", premium: "Offizieller Premium-Sponsor", intermediario: "Co-Sponsor", apoiante: "Unterstützer" },
            tiersPlural: { exclusiva: "Exklusive Sponsorin", oficial: "Offizieller Partner", premium: "Premium-Sponsoren", intermediario: "Co-Sponsoren", apoiante: "Unterstützer" },
        },
        quotas: {
            titulo: "MITGLIEDERBEITRÄGE UND MITGLIEDSCHAFT",
            valor: "Beitrag: CHF 2 pro Monat (CHF 24 pro Jahr).",
            isencao: "Die Gründungsmitglieder und die Ehrenmitglieder sind dauerhaft vom Beitrag befreit.",
            comoPagar: "So zahlen Sie den Beitrag. Solange das Bankkonto des Vereins bestimmt wird, kann der Beitrag in bar direkt bei {famosa} bezahlt werden. Bewahren Sie den Zahlungsnachweis auf und fügen Sie ihn dem Beitrittsgesuch bei.",
            admissao: "Aufnahme. Das Beitrittsgesuch wird vom Vorstand geprüft, der gemäß Art. 6 der Statuten entscheidet.",
            categoriasTitulo: "Mitgliederkategorien (Art. 5 der Statuten)",
            fundadores: "Gründungsmitglieder — dauerhaft vom Beitrag befreit",
            efetivos: "Ordentliche Mitglieder — natürliche oder juristische Personen, vom Vorstand aufgenommen",
            honorarios: "Ehrenmitglieder — besondere Verdienste um den Verein, vom Beitrag befreit",
            apoiantes: "Fördermitglieder — unterstützen den Verein finanziell; ohne Stimmrecht",
        },
        form: {
            titulo: "BEITRITTSGESUCH",
            nome: "Vollständiger Name", rua: "Strasse und Nummer", cp: "Postleitzahl", localidade: "Ort", pais: "Land",
            email: "E-Mail", telefone: "Telefon", telefoneOpc: "optional",
            categoria: "Gewünschte Kategorie", catEfetivo: "Ordentliches Mitglied", catApoiante: "Fördermitglied",
            comprovativo: "Zahlungsnachweis des Beitrags",
            comprovativoNota: "PDF, JPG oder PNG · max. 10 MB",
            escolherFicheiro: "Datei wählen",
            aceiteEstatutos: "Ich habe die Statuten des Vereins Fados à Mesa gelesen und akzeptiere sie.",
            verEstatutos: "Statuten ansehen",
            aceiteDados: "Ich willige ein, dass der Verein Fados à Mesa meine Personendaten ausschließlich zur Bearbeitung meines Beitritts gemäß dem Bundesgesetz über den Datenschutz (nDSG) bearbeitet.",
            verNota: "Datenschutzhinweis ansehen",
            enviar: "Gesuch senden", aEnviar: "Wird gesendet...",
            sucesso: "Gesuch erhalten. Ihr Beitrittsgesuch wird vom Vorstand geprüft. Sie erhalten die Antwort per E-Mail.",
            erroObrigatorio: "Pflichtfeld",
            erroEmail: "Ungültige E-Mail",
            erroFicheiroTipo: "Nur PDF, JPG oder PNG",
            erroFicheiroGrande: "Die Datei überschreitet 10 MB",
            erroGeral: "Das Gesuch konnte nicht gesendet werden. Bitte erneut versuchen.",
        },
        estatutos: { titulo: "STATUTEN", indice: "Inhalt", descarregar: "Statuten herunterladen (PDF)" },
        cartao: {
            titulo: "MITGLIEDSAUSWEIS",
            categoriaEfetivo: "Ordentliches Mitglied", categoriaApoiante: "Gönnermitglied",
            numero: "Mitglied Nr.", desde: "Mitglied seit", valido: "Gültiger Ausweis",
            guardar: "Bild speichern", partilhar: "Teilen",
            nota: "Zeigen Sie diesen Ausweis an Anlässen des Vereins Fados à Mesa vor. Speichern Sie das Bild auf Ihrem Handy oder fügen Sie diese Seite dem Home-Bildschirm hinzu.",
            invalidoTitulo: "Ungültiger Ausweis",
            invalidoTexto: "Dieser Mitgliedsausweis ist nicht gültig oder wurde widerrufen. Bei Fragen kontaktieren Sie uns über die Kontaktseite.",
            aCarregar: "Ausweis wird geprüft…",
        },
        protecao: {
            titulo: "DATENSCHUTZ",
            texto: "Der Verein Fados à Mesa bearbeitet Personendaten seiner Mitglieder und Gesuchsteller ausschließlich für die Verwaltung der Mitgliedschaften und die Tätigkeiten des Vereins, in Übereinstimmung mit dem Bundesgesetz über den Datenschutz (nDSG) und Art. 27 der Statuten. Die Daten werden niemals für kommerzielle Zwecke an Dritte weitergegeben. Um Ihre Daten einzusehen, zu korrigieren oder zu löschen, kontaktieren Sie produktion@fadosamesa.ch.",
        },
    },
    faq: {
        titulo: "Häufige Fragen",
        items: [
            { q: "Sind Getränke im Ticket inbegriffen?", a: "Das Ticket beinhaltet Portwein zur Begrüßung, Vorspeisen, Suppe, Hauptgang, Dessert und einen Kaffee pro Person. Getränke und Digestifs sind separat." },
            { q: "Muss ich meinen Hauptgang bestätigen?", a: "Ja. Bestätigen Sie Ihre Teilnahme und die Wahl des Hauptgangs (Fisch oder Fleisch) bis zum 1. November 2026 unter fadosamesa.ch/confirmar." },
            { q: "Wo kaufe ich Tickets?", a: "Im offiziellen Ticketshop unter fadosamesa.ch/bilhetes (Eventim Light / Ticket Corner). Das Event ist exklusiv und die Plätze sind begrenzt." },
            { q: "Wie komme ich zum Centro Papa Giovanni?", a: "Hübelistrasse 55, 6020 Emmenbrücke — 10 Gehminuten vom Bahnhof Emmenbrücke Gersag, mit kostenlosen Parkplätzen in der Umgebung. Alle Details unter fadosamesa.ch/local." },
        ],
    },
    experiencia: {
        tabs: { menu: "Menü des Abends", cultura: "Kultur & Tradition", gastro: "Gastronomie & Weine", bar: "Bar" },
        bar: {
            nome: "A Famosa — Café & Sabores",
            cargoA: "Betrieb und Service durch die",
            cargoB: "Pastelaria Famosa de Emmenbrücke",
            horarioTitulo: "Öffnungszeiten",
            blocos: [
                { horas: "17H00 – 18H30", estado: "Geöffnet", nota: "Empfang und Porto de Honra (Begrüßungsgetränk), bis zum Servieren der Vorspeisen des Abendessens." },
                { horas: "18H30 – 23H30", estado: "Geschlossen", nota: "Während der gesamten Veranstaltung." },
                { horas: "23H30 – 01H00", estado: "Wieder geöffnet", nota: "Durchgehend bis zur Schließung des Lokals." },
            ],
            regra: "Die Exklusivitätsregel und die Zahlung zum Zeitpunkt des Kaufs bleiben bestehen.",
        },
        tituloA: "Ein ",
        tituloGold: "portugiesischer",
        tituloB: " Abend,",
        tituloC: "am Tisch serviert.",
        p1: "Fados à Mesa ist ein Dinner-Spektakel, das das Beste zweier Kulturgüter vereint: die portugiesische Gastronomie und den Fado. Zwischen den Gängen erfüllen die Portugiesische Gitarre und die Stimme des Fadista den Raum — wie in den Fado-Häusern Lissabons, nur hier, in der Schweiz.",
        p2: "Ein ganzer Abend, bis ins Detail durchdacht: der gedeckte Tisch, die brennenden Kerzen, der servierte Wein und die heilige Stille, wenn der Fado beginnt.",
        menuLabel: "Offizielles Menü der 1. Ausgabe",
        menuOficial: {
            bebidasTitulo: "Getränke sind separat.",
            bebidasTexto: "Sie sind nicht im Ticketpreis inbegriffen.",
            entradas: "Vorspeisen",
            sopa: "Suppe",
            sopaValor: "Caldo Verde",
            sopaTrad: "traditionelle portugiesische Grünkohlsuppe",
            prato: "Hauptgang",
            peixeLabel: "Option 1 — Fisch",
            peixeValor: "Lombo de Bacalhau Assado no Forno com Batata a Murro",
            peixeTrad: "im Ofen gebratener Kabeljaurücken mit gestossenen Kartoffeln",
            carneLabel: "Option 2 — Fleisch",
            carneValor: "Lombo de Porco com Batata Assada e Arroz",
            carneTrad: "gebratene Schweinelende mit Ofenkartoffeln und Reis",
            acompanhamento: "Beide werden mit Blattsalat und Tomaten serviert.",
            sobremesa: "Dessert",
            sobremesaNota: "Eine von zwei Optionen zur Auswahl",
            sobremesaOpcoes: "Hausgemachter Pudding · Obstsalat",
            final: "Zum Abschluss",
            finalValor: "Kaffee",
            notaBilhetes: "Tickets aus derselben Buchung garantieren wann immer möglich Plätze am selben Tisch.",
            notaSilencio: "Um die Magie des live gespielten Fado zu bewahren, bitten wir Sie, den Saal nur während der Pausen zu betreten oder zu verlassen.",
            notaEstacionamento: "Kostenlose Parkplätze in der Nähe des Centro Papa Giovanni (gehören nicht zum Saal; je nach Verfügbarkeit).",
            notaRececao: "Folgen Sie bei Ihrer Ankunft bitte den Anweisungen unseres Empfangsteams.",
            fecho: "Wir freuen uns darauf, Sie zu einem unvergesslichen Abend voller portugiesischer Kultur, Gastronomie und der zeitlosen Tradition des Fado zu begrüssen.",
        },
        zoomHint: "Tippen Sie auf das Menü, um es zu vergrößern",
        importante: "Wichtig",
        notaA: "Jeder Gast sollte seine Teilnahme und die Wahl des Hauptgangs (Fisch oder Fleisch) bis zum ",
        notaB: "Jeder Gast sollte seine Teilnahme und die Wahl des Hauptgangs bis zum ",
        prazoData: "1. November 2026",
        confirmar: "Hauptgericht bestätigen",
        culturaTitulo: "DER ABEND, MOMENT FÜR MOMENT",
        lineupTitulo: "Line-up des Abends",
        lineup: [
            { hora: "17h00", momento: "Ankunft der Gäste (bis 17:30 Uhr)" },
            { hora: "17h00", momento: "Bar geöffnet (bis 18:30 Uhr)", link: true },
            { hora: "17h30", momento: "Portwein zur Begrüßung" },
            { hora: "18h30", momento: "Vorspeisen und Getränke werden am Tisch serviert" },
            { hora: "19h00", momento: "Erste Fado-Show" },
            { hora: "19h30", momento: "Suppe" },
            { hora: "20h30", momento: "Zweiter Fado-Moment" },
            { hora: "21h00", momento: "Hauptgang" },
            { hora: "21h45", momento: "Dritter Fado-Moment" },
            { hora: "22h30", momento: "Dessert und Kaffee" },
            { hora: "22h30", momento: "Die Küche schließt" },
            { hora: "23h00", momento: "Der letzte Fado des Abends" },
            { hora: "23h45", momento: "Saalschluss — nur noch Barbetrieb, bis 01:00 Uhr (Schließung des Raums)", link: true },
            { hora: "01h30", momento: "Centro Papa Giovanni schließt" },
        ],
        lineupLink: "Bar-Öffnungszeiten ansehen",
        lineupNota: "Richtzeiten der 1. Ausgabe — vorbehaltlich Bestätigung.",
        etiquetaTitulo: "Wenn der Fado gesungen wird",
        etiquetaTexto: "«Stille, jetzt wird der Fado gesungen.» Auf portugiesische Art verstummt der Saal, sobald die Gitarre beginnt: Man hört respektvoll zu, fühlt in Stille und applaudiert am Ende. So ist es in Lissabon — und so wird es an unserem Tisch sein.",
        bilheteTitulo: "Ihr Ticket beinhaltet",
        incluido: [
            "Portwein zur Begrüßung bei der Ankunft",
            "Vorspeisen",
            "Suppe",
            "Hauptgang",
            "Dessert",
            "1 Kaffee pro Person",
        ],
        bebidas: "Getränke und Digestifs sind separat.",
        exclusivo: "Exklusives Event — begrenzte Plätze",
        gastroTitulo: "GASTRONOMIE UND WEINE",
        gastroCardTitulo: "Portugiesische Gastronomie",
        gastroP1: "Unsere Gerichte entstehen aus Produkten portugiesischen Ursprungs, ausgewählt mit dem Respekt dessen, der für die Familie kocht: das Olivenöl, der Stockfisch, die Wurstwaren und die Süßspeisen, die Grenzen überqueren, um Ihren Tisch so zu erreichen, wie man es in Portugal tut.",
        gastroP2: "Wer jedes Gericht zubereitet, wird in Kürze vorgestellt — unsere Küche wird mit derselben Sorgfalt ausgewählt, mit der man eine Gitarre stimmt.",
        vinhosCardTitulo: "Portugiesische Weine",
        vinhosP1: "Eine Auswahl von Weinen aus den besten Regionen Portugals — vom Douro bis zum Alentejo, vom Dão bis zu den Vinhos Verdes des Minho — gedacht, um jeden Moment des Abendessens und jeden Fado der Nacht zu begleiten.",
        vinhosP2: "Die Weinkarte der 1. Ausgabe wird in Kürze enthüllt.",
    },
    equipa: {
        titulo: "UNSER TEAM",
        tabs: { producao: "Produktion", staff: "Staff" },
        producaoTitulo: "Produktionsteam",
        staffTitulo: "Staff — Küche, Service und Bar",
        cozinhaTitulo: "Küche",
        salaTitulo: "Service",
        barTitulo: "Bar",
        apoioTitulo: "Küchen- und Serviceteam",
        producao: [
            {
                id: "paula-angelino", nome: "Paula Angelino", papel: "Künstlerische und Kreative Geschäftsführerin",
                texto: "Verantwortlich für die künstlerische und kreative Vision von Fados à Mesa, leitet sie die Identität des Projekts, die Kommunikation und die Produktion. Ihr Ziel ist es, die portugiesische Kultur durch authentische Erlebnisse zu fördern, die Musik, Gastronomie und Tradition verbinden.",
            },
            {
                id: "paula-silva", nome: "Paula Silva", papel: "Leiterin Logistik und Personal",
                texto: "Verantwortlich für die operative Organisation und die Koordination der Teams, stellt sie sicher, dass jedes Detail mit Sorgfalt geplant wird und jede Veranstaltung mit Qualität und portugiesischer Gastfreundschaft abläuft.",
            },
            {
                id: "paulo-nunes", nome: "Paulo Nunes", papel: "Technischer Leiter und Sicherheitsverantwortlicher",
                texto: "Verantwortlich für die technische Koordination und die Sicherheit der Räumlichkeiten, garantiert er, dass jede Veranstaltung mit Exzellenz, Professionalität und vollem Vertrauen abläuft.",
            },
        ],
        cozinha: [
            {
                id: "fernando-rocha", nome: "Fernando Rocha", papel: "Küchenchef",
                texto: "Verantwortlich für die Kreation und Ausführung der Menüs, sichert er die Qualität, Authentizität und Präsentation jedes Gerichts und würdigt dabei die besten Zutaten und die Tradition der portugiesischen Gastronomie.",
            },
            {
                id: "cristina-moita", nome: "Cristina Moita", papel: "Sous-Chefin",
                texto: "Verantwortlich für die Unterstützung der Küchenleitung und die Koordination des Teams, gewährleistet sie Organisation, Sorgfalt und das reibungslose Funktionieren aller Bereiche, damit jedes Detail mit Exzellenz auf den Tisch kommt.",
            },
        ],
        apoio: ["Cátia Ambrai", "Paulo", "Márcia Pinheiro"],
        sala: {
            id: "sergio-rego", nome: "Sérgio Rêgo", papel: "Serviceleiter",
            texto: "Direkt aus Lissabon kommend, arbeitet er täglich mit den Künstlern, die wir präsentieren, und sorgt für einen aufmerksamen, diskreten und exzellenten Service, damit jeder Abend zu einem unvergesslichen Erlebnis wird.",
        },
        salaApoio: { nome: "Rui Borges", papel: "Service-Unterstützung" },
        barMembro: { nome: "Rui Borges", papel: "Pastelaria Famosa de Emmenbrücke" },
    },
    missao: {
        label: "Die Mission",
        tituloA: "DIE ",
        tituloGold: "PORTUGIESISCHE KULTUR",
        tituloB: " IN DIE SCHWEIZ BRINGEN",
        subtitulo: "Der Abend, an dem Portugal die Schweiz einlädt, sich an unseren Tisch zu setzen — eine Hommage an eine Freundschaft, die über Generationen zwischen dem portugiesischen Volk und dem Land gewachsen ist, das es aufgenommen hat.",
        capitulos: [
            {
                titulo: "Der Ursprung",
                paragrafos: [
                    "Fados à Mesa entstand aus dem Wunsch, den Fado in seiner authentischsten Form zu präsentieren und die Tradition einer künstlerischen Ausdrucksform zu respektieren, die von der UNESCO als Immaterielles Kulturerbe der Menschheit anerkannt wurde.",
                    "Mehr als ein Musikgenre ist der Fado eine Art, Erinnerungen zu bewahren, Emotionen zu vermitteln und die Geschichte eines Volkes zu erzählen. Er ist ein lebendiges Erbe, das Generationen überdauert und Menschen durch Poesie, Musik und portugiesische kulturelle Identität weiterhin verbindet.",
                ],
            },
            {
                titulo: "Mehr als ein Konzert",
                paragrafos: [
                    "Deshalb erlebt man einen Fado-Abend nicht wie ein herkömmliches Konzert. Man erlebt ihn in intimer Atmosphäre, in der die Nähe zwischen Künstlern und Publikum ein zutiefst menschliches Erlebnis schafft. Jede Darbietung wird mit Respekt gehört, jedes Wort wird geschätzt und jede Stille ist Teil der Musik.",
                ],
            },
            {
                titulo: "Kultur Verdient Zeit",
                paragrafos: [
                    "Bei Fados à Mesa glauben wir, dass Kultur Zeit verdient. Sie verdient Aufmerksamkeit. Sie verdient einen Raum, in dem das Erbe mit Authentizität, Würde und Eleganz erlebt werden kann.",
                    "Die Veranstaltung wurde sorgfältig konzipiert, um ein kulturelles Erlebnis von höchster Qualität zu bieten, bei dem die portugiesische Tradition auf zeitgemäße, einladende Weise präsentiert wird — getreu der internationalen Anerkennung, die der Fado errungen hat.",
                ],
            },
            {
                titulo: "Portugal Auf Reisen",
                paragrafos: [
                    "Wenn die Entfernung die Rückkehr nach Portugal erschwert, ist es Portugal, das zu denen reist, die es vermissen. Fados à Mesa entsteht auch aus diesem Zweck: für eine Nacht eine Atmosphäre wiederzuerwecken, in der Erinnerung, Identität und Zugehörigkeitsgefühl durch portugiesische Musik, Tradition und Kultur wieder lebendig werden.",
                ],
            },
            {
                titulo: "Eine Einladung an die Schweiz",
                paragrafos: [
                    "Aber dieses Projekt geht über die portugiesische Gemeinschaft hinaus. Es ist auch eine Geste der Freundschaft und des Teilens. Es ist Portugal, das die Schweiz einlädt, an unserem Tisch Platz zu nehmen. Eine Einladung, eine weltweit anerkannte Kultur zu entdecken — nicht nur wegen der Schönheit ihrer Musik, sondern auch wegen der Authentizität, Gastfreundschaft und des Reichtums ihres Erbes.",
                    "Mehr als ein Dinner-Spektakel möchte sich Fados à Mesa als Begegnungsort zwischen Kulturen etablieren, an dem Portugiesen, Schweizer und Besucher unterschiedlichster Herkunft am selben Tisch sitzen, denselben Geschichten lauschen und entdecken, dass Kultur eine universelle Sprache ist, die Menschen einander näherbringt.",
                ],
            },
        ],
        valores: [
            { n: "I", title: "Kultur", text: "Den Fado — immaterielles Erbe der Menschheit — zu neuem Publikum bringen." },
            { n: "II", title: "Tisch", text: "Die Gastronomie und Weine teilen, die Portugals Geschichte erzählen." },
            { n: "III", title: "Begegnung", text: "Einen Begegnungspunkt zwischen Kulturen in der Schweiz schaffen, rund um den Tisch." },
        ],
        fechoA: "In einer Zeit, in der so viele Erlebnisse in Eile gelebt werden, lädt der Fado uns ein, genau das Gegenteil zu tun: innezuhalten, zuzuhören und zu fühlen.",
        fechoB: "Denn es gibt Momente, in denen das größte Zeichen des Respekts nicht der Applaus ist. Es ist die Stille.",
        fechoFinal: "Stille... gleich wird Fado gesungen.",
    },
    contacto: {
        titulo: "KONTAKTIEREN SIE UNS",
        intro: "Für alles rund um Fados à Mesa schreiben Sie uns hier — wir antworten gerne.",
        nome: "Name",
        nomePh: "Ihr Name",
        email: "E-Mail",
        emailPh: "ihreemail@beispiel.ch",
        assunto: "Betreff",
        assuntos: [
            "Gruppenreservierungen",
            "Partnerschaften und Sponsoring",
            "Presse und Medien",
            "Fragen zur 1. Ausgabe",
            "Anderes Anliegen",
        ],
        mensagem: "Nachricht",
        mensagemPh: "Schreiben Sie Ihre Nachricht...",
        enviar: "Nachricht senden",
        aEnviar: "Wird gesendet...",
        erroGenerico: "Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
        sucessoTitulo: "Nachricht gesendet.",
        sucessoTexto: "Danke, {nome}. Wir haben Ihre Nachricht erhalten und antworten in Kürze.",
        fecho: "Ein portugiesischer Abend, ganz bestimmt.",
    },
    local: {
        label: "Wo die Veranstaltung stattfindet",
        titulo: "ANREISE",
        intro: "Alle praktischen Informationen zum Veranstaltungsort und zur Anreise nach Emmenbrücke — mit öffentlichen Verkehrsmitteln, dem Auto, Uber/Taxi oder dem Fahrrad.",
        morada: "Hübelistrasse 55, 6020 Emmenbrücke, Schweiz — 47.0706° N, 8.2849° E",
        moradaCurta: "Hübelistrasse 55, 6020 Emmenbrücke",
        comoChegar: "ANREISE",
        cards: [
            {
                id: "transportes",
                title: "Mit öffentlichen Verkehrsmitteln",
                text: "Der Bahnhof Emmenbrücke Gersag ist etwa 10 Gehminuten entfernt und wird von Regionalzügen sowie den Bussen 41, 42, 43 und 44 bedient. Von Luzern verbindet die VBL-Linie 2 mit dem Zentrum von Emmenbrücke; für die Rückfahrt verkehrt der Nachtbus N2 nach Luzern.",
            },
            {
                id: "carro",
                title: "Mit dem Auto",
                text: "5 Minuten von der Autobahn A2 (Ausfahrt Emmen Nord). Kostenloser Häger-Parkplatz direkt gegenüber, beschränkt auf die mit «Häger» gekennzeichneten Plätze — alle Details unten.",
            },
            {
                id: "uber",
                title: "Mit Uber oder Taxi",
                text: "Uber ist in Luzern und Umgebung tätig: eine Fahrt vom Zentrum Luzerns dauert etwa 10 Minuten.",
            },
            {
                id: "bicicleta",
                title: "Mit dem Fahrrad",
                text: "Emmen ist nur wenige Fahrradminuten von Luzern entfernt, über ruhige Radwege. Fahrradparkplätze sind vor Ort vorhanden.",
            },
        ],
        mapsCta: "In Google Maps öffnen",
        mapsTexto: "Richten Sie die Kamera auf den Code oder tippen Sie hier — der genaue Standort und die nächsten Parkplätze sind nur einen Tipp entfernt.",
        barTitulo: "Bar im Lokal",
        barTexto: "Geöffnet 17:00–18:30 und 23:30–01:00 Uhr. Betrieb durch die Pastelaria Famosa de Emmenbrücke — Zahlung beim Kauf.",
        estacionamentoHager: {
            titulo: "Kostenlose Parkplätze — Häger",
            intro: "Der nächstgelegene Parkplatz ist der der Firma Häger, direkt gegenüber dem Centro Papa Giovanni — kostenlos, jedoch begrenzt auf die Kapazität des Platzes.",
            pontos: [
                "Nur die mit «Häger» gekennzeichneten Plätze stehen den Gästen der Veranstaltung zur Verfügung.",
                "Diese Angaben dienen lediglich zur Information: Wir übernehmen keine Verantwortung für die Belegung. Parken ist kostenlos — eine Bezahlung ist nicht nötig.",
                "Sollte der Parkplatz belegt sein, finden Sie in der näheren Umgebung mehrere weitere Parkmöglichkeiten — teils kostenlos, teils kostenpflichtig.",
            ],
            mapsCta: "Parkplatz in Google Maps ansehen",
        },
        fecho: "Ankommen ist einfach. Das Schwierige wird sein, wieder zu gehen.",
    },
    noticias: {
        label: "Pressebereich",
        titulo: "NACHRICHTEN",
        intro: "Willkommen auf der offiziellen News-Seite von Fados à Mesa. Hier finden Sie die neuesten offiziellen Ankündigungen von Fados à Mesa sowie sorgfältig ausgewählte Nachrichten über die Künstlerinnen und Künstler unserer Veranstaltung. Unser Ziel ist es, Sie über zuverlässige, offizielle Quellen zu informieren und die Künstler hervorzuheben, die dieses Projekt möglich machen. Diese Seite wird regelmässig aktualisiert, sobald neue offizielle Informationen vorliegen.",
        socialTitulo: "UNSER NEUESTER BEITRAG",
        socialTituloMulti: "UNSERE NEUESTEN BEITRÄGE",
        socialVer: "Beitrag ansehen",
        socialSeguir: "Folgen Sie uns",
        socialBio: "Fados à Mesa ist jetzt auf Instagram — folgen Sie uns für offizielle Ankündigungen, die Künstler und Einblicke hinter die Kulissen des Abends.",
        verTodas: "Alle Nachrichten ansehen",
        ultimasTitulo: "AKTUELLE NACHRICHTEN",
        filtros: { todas: "Alle", projeto: "Fados à Mesa" },
        pesquisaPh: "Nachrichten nach Stichwort suchen...",
        lerMais: "Mehr lesen",
        carregarMais: "Mehr laden",
        aCarregar: "Wird geladen...",
        semResultados: "Keine Nachrichten gefunden. Versuchen Sie einen anderen Künstler oder ein anderes Stichwort.",
        fonte: "Quelle",
        ctaTitulo: "Erleben Sie Fado Live",
        ctaReservar: "Platz Reservieren",
    },
    patrocinadoresPage: {
        titulo: "OFFIZIELLE SPONSOREN",
        texto: "Die Partner, die diesen Abend möglich machen — danke, dass Sie an die portugiesische Kultur in der Schweiz glauben.",
    },
    confirmacao: {
        label: "1. Ausgabe · 14. November 2026",
        titulo: "BESTÄTIGEN SIE IHRE TEILNAHME",
        introA: "Bestätigen Sie Ihre Teilnahme und wählen Sie Ihren Hauptgang bis zum ",
        prazoData: "1. November 2026",
        nome: "Vollständiger Name",
        nomePh: "Ihr Name",
        email: "E-Mail",
        emailPh: "ihreemail@beispiel.ch",
        bilhete: "Ticketnummer (Ticket Corner)",
        bilhetePh: "Z. B.: TC-123456789",
        escolhePrato: "Wählen Sie Ihren Hauptgang",
        opcoes: [
            { id: "peixe", title: "Option 1 — Fisch", desc: "Gebackenes Stockfischsteak mit Ofenkartoffeln und Salat" },
            { id: "carne", title: "Option 2 — Fleisch", desc: "Gebratene Schweinelende mit Ofenkartoffeln und Salat" },
        ],
        submit: "Teilnahme bestätigen",
        aRegistar: "Wird registriert...",
        erroGenerico: "Die Bestätigung konnte nicht registriert werden. Bitte versuchen Sie es erneut.",
        sucessoTitulo: "Teilnahme bestätigt.",
        sucessoTexto: "Danke, {nome}. Ihre Wahl ({prato}) wurde registriert. Bis bald — am 14. November, am Tisch.",
        peixe: "Fisch",
        carne: "Fleisch",
    },
    vantagens: {
        label: "Mitglieder",
        titulo: "MITGLIEDERVORTEILE UND PARTNERSCHAFTEN",
        intro: "Die Mitgliedschaft bei Fados à Mesa kostet CHF 2 pro Monat (CHF 24 pro Jahr) und bietet Rabatte an verschiedenen Orten in Portugal und in der Schweiz – bereits ab der 1. Ausgabe.",
        prova: "Um die Vorteile zu nutzen, zeigen Sie einfach Ihre digitale Mitgliedskarte (mit QR-Code) vor oder nennen Sie Ihre Mitgliedsnummer.",
        bilhetesTitulo: "Tickets der 1. Ausgabe – 14. November 2026",
        bilhetesIntro: "Sofortrabatt beim Kauf physischer Tickets in der Pastelaria Famosa, Emmenbrücke (Bargeld, Twint oder Überweisung).",
        colBilhete: "Ticket",
        colAte: "Bis 31.10.2026",
        colDepois: "Ab 01.11.2026",
        linhas: [
            ["Erwachsene, Normalpreis", "CHF 119.90", "CHF 129.90"],
            ["Mitglied, 1. Erwachsenenticket (− CHF 20)", "CHF 99.90", "CHF 109.90"],
            ["Erwachsene im Kauf zusammen mit Mitglied (− CHF 10)", "CHF 109.90", "CHF 119.90"],
            ["Kind (6–15 Jahre)", "CHF 65.00", "CHF 65.00"],
            ["Kind im Kauf zusammen mit Mitglied (− CHF 5)", "CHF 60.00", "CHF 60.00"],
        ],
        bilhetesNota: "Mitgliederrabatte gelten nur für Tickets, die zusammen mit dem Mitglied in derselben Transaktion gekauft werden. Die Mitgliedsnummer muss zur internen Erfassung auf allen Tickets vermerkt sein.",
        fisicoTitulo: "Warum nur physische Tickets?",
        fisicoTexto: "Aus Gründen des Projektmanagements sind die Tickets mit Mitgliederrabatt in dieser 1. Ausgabe nur physisch in der Pastelaria Famosa erhältlich. Wir möchten dies in einer nächsten Ausgabe lösen und den Rabatt auch auf den Online-Kauf ausweiten.",
        protocolosTitulo: "Partnervereinbarungen",
        srVinhoTitulo: "Sr. Vinho – Typisches Restaurant",
        srVinhoTag: "Offizieller Partner",
        srVinhoTexto: "Alle Mitglieder von Fados à Mesa erhalten ab sofort 10% Rabatt bei Barzahlung auf den Endbetrag des Abendessens im Restaurant Sr. Vinho sowie einen Digestif gratis.",
        srVinhoCta: "Menü des Sr. Vinho ansehen",
        famosaTitulo: "Pastelaria Famosa – Emmenbrücke",
        famosaTag: "Exklusive Sponsorin",
        famosaTexto: "Offizielle Verkaufsstelle der physischen Tickets mit Mitgliederrabatt für die 1. Ausgabe. Zahlung in bar, per Twint oder Überweisung.",
        cr7Titulo: "CR7 Helder – Limousinen-Transport",
        cr7Tag: "Offizieller Premium-Sponsor",
        cr7Texto: "Mit dem Code CR7 erhalten Mitglieder 10% Rabatt auf alle Limousinen von Vachoux (Helder Pacheco). Angebot beschränkt auf das Stadtgebiet von Genf, für Fahrten von 45 Minuten, mit Limousinen für maximal 12 bis 16 Personen.",
        cr7Codigo: "Code: CR7",
        cr7Cta: "Buchen auf vachoux.com",
        emBreve: "Weitere Partnerschaften in Portugal und der Schweiz folgen in Kürze. Die Mitglieder werden per E-Mail informiert.",
        ctaTitulo: "Noch kein Mitglied?",
        ctaTexto: "Einfache Online-Anmeldung für CHF 24/Jahr.",
        cta: "Mitglied werden",
    },
    bilhetes: {
        precosTitulo: "Ticketpreise",
        precosStandard: "Standard",
        precosEarlyBird: "Early Bird",
        precosNormal: "Normalpreis",
        precosCrianca: "Kind (6–15 Jahre)",
        precosCriancaNota: "Abendessen mit Wasser und einem Hausaft gratis · Ohne Porto de Honra",
        socioLink: "Mitglieder: CHF 20 Rabatt auf das 1. Ticket – Mitgliedervorteile ansehen",
        precosNota: "Getränke nicht inbegriffen · Begrenzte Platzzahl · Dresscode: elegante Dinner-Kleidung (keine Gala, aber fast)",
        titulo: "TICKETSHOP",
        data: "14. November 2026 · Centro Papa Giovanni, Emmenbrücke",
        exclusivo: "Exklusives Event · Begrenzte Plätze",
        confirmarReserva: "Reservierung bestätigen",
        nota: "Offizieller Eventim-Ticketshop. Bestätigen Sie nach dem Kauf Ihre Teilnahme und Menüwahl unter ",
    },
    ticketcorner: { label: "OFFIZIELLER VERTRIEBSPARTNER" },
    privacidade: {
        label: "Fados à Mesa",
        titulo: "DATENSCHUTZERKLÄRUNG",
        seccoes: [
            {
                title: "1. Verantwortliche Stelle",
                text: "Verantwortlich für die Bearbeitung personenbezogener Daten auf dieser Website ist der Verein Fados à Mesa (nachfolgend «wir»), UID CHE-306.330.271, Gerliswilstrasse 46, 6020 Emmenbrücke, Schweiz. Bei Fragen zum Datenschutz kontaktieren Sie uns über die Kontaktseite.",
            },
            {
                title: "2. Rechtlicher Rahmen",
                text: "Die Bearbeitung personenbezogener Daten erfolgt im Einklang mit dem Schweizer Bundesgesetz über den Datenschutz (nDSG, in Kraft seit dem 1. September 2023) sowie der übrigen anwendbaren Schweizer Gesetzgebung.",
            },
            {
                title: "3. Daten, die wir erheben",
                text: "In dieser Phase erhebt die Website keine personenbezogenen Daten über Formulare. Wenn Sie uns per E-Mail kontaktieren, bearbeiten wir Ihre Adresse und den Inhalt der Nachricht nur, um Ihr Anliegen zu beantworten. Daten zu Reservierungen oder Ticketkäufen werden künftig über die Plattform Ticket Corner gemäss deren Datenschutzrichtlinie bearbeitet.",
            },
            {
                title: "4. Cookies und Analysewerkzeuge",
                text: "Diese Website verwendet derzeit keine Tracking-Cookies und keine Analysewerkzeuge von Drittanbietern. Sollten diese eingeführt werden, wird diese Richtlinie entsprechend aktualisiert.",
            },
            {
                title: "5. Ihre Rechte",
                text: "Nach Schweizer Recht haben Sie das Recht, Auskunft über Ihre personenbezogenen Daten sowie deren Berichtigung oder Löschung zu verlangen. Um diese Rechte auszuüben, kontaktieren Sie uns über die Kontaktseite.",
            },
            {
                title: "6. Änderungen",
                text: "Wir behalten uns das Recht vor, diese Richtlinie jederzeit zu aktualisieren. Es gilt die auf dieser Seite veröffentlichte Version. Letzte Aktualisierung: September 2026.",
            },
        ],
    },
    termos: {
        label: "Fados à Mesa",
        titulo: "ALLGEMEINE GESCHÄFTSBEDINGUNGEN",
        seccoes: [
            {
                title: "1. Gegenstand",
                text: "Diese Allgemeinen Geschäftsbedingungen regeln die Nutzung der Website Fados à Mesa und die Teilnahme an der Veranstaltung. Mit der Nutzung dieser Website akzeptieren Sie diese Bedingungen vollumfänglich.",
            },
            {
                title: "2. Geistiges Eigentum",
                text: "Das Konzept, die Bezeichnung «Fados à Mesa», das Logo, die Texte, die Fotografien, die Videos, das Design und sämtliche Inhalte dieser Website sind ausschliessliches Eigentum der Veranstalterorganisation und durch das Schweizerische Bundesgesetz über das Urheberrecht und verwandte Schutzrechte (URG) sowie durch die anwendbaren internationalen Übereinkommen geschützt. Die Vervielfältigung, das Kopieren, die Nachahmung, die Verbreitung oder die ganz oder teilweise Verwendung des Konzepts, der Marke, der Texte, der Bilder oder eines unterscheidenden Elements des Projekts ist ohne vorherige schriftliche Genehmigung der Organisation ausdrücklich untersagt. Jede Verletzung wird nach Schweizer Recht gerichtlich verfolgt.",
            },
            {
                title: "3. Tickets und Reservierungen",
                text: "Der Ticketverkauf erfolgt über die Plattform Ticket Corner, deren Geschäftsbedingungen Anwendung finden. Die Veranstaltung hat ein begrenztes Platzangebot; eine Reservierung ist erst nach Bestätigung der Zahlung gültig.",
            },
            {
                title: "4. Programm und Änderungen",
                text: "Die Organisation behält sich das Recht vor, das Programm, die Zeiten, das Menü und die Besetzung aus Gründen höherer Gewalt anzupassen, wobei die Qualität des angekündigten Erlebnisses stets gewährleistet wird.",
            },
            {
                title: "5. Haftung",
                text: "Die Organisation haftet nicht für Schäden, die aus Informationen Dritter, fremden technischen Störungen oder unsachgemässer Nutzung der Website entstehen. Der Konsum alkoholischer Getränke ist gemäss Schweizer Gesetzgebung Erwachsenen vorbehalten.",
            },
            {
                title: "6. Anwendbares Recht und Gerichtsstand",
                text: "Diese Bedingungen unterliegen Schweizer Recht. Für allfällige Streitigkeiten ist das Gericht am Sitz der Organisation in der Schweiz zuständig. Letzte Aktualisierung: September 2026.",
            },
        ],
    },
    artistPage: {
        naoEncontrado: "Künstler nicht gefunden.",
        imprensa: "Presse & Highlights",
        emPalco: "Auf der Bühne",
        oQueA: "Was Sie ",
        oQueGold: "erwartet",
        oQueB: "",
    },
    artists: {
        "rafael-pacheco": {
            role: "Portugiesische Gitarre",
            bio: "Geboren in Portimão (2000), begann er mit 11 Jahren an der Fado-Schule Boa Esperança und wurde von dem renommierten Portugiesischen Gitarristen Antunes, dem Prinzen, ausgebildet.\n\nGewinner des Ageas-Nachwuchstalent-Preises in der Casa da Música (2023), ist er residierender Musiker in emblematischen Fado-Häusern, von Viseu bis Lissabon.",
        },
        "ginestal-martins": {
            role: "Viola de Fado",
            bio: "Als Fado-Violist der Lissaboner Szene ist er das musikalische Fundament unzähliger Abende — die Viola, die jede Stimme mit Feingefühl trägt.\n\nEr begleitet Fadistas in den Fado-Häusern und bei den Visitas Cantadas der EGEAC durch die historischen Viertel Lissabons, an der Seite von Gitarristen wie Rafael Pacheco. Er tritt auch selbst als Fadista auf.",
        },
        "catia-garcia": {
            role: "Fadista",
            bio: "Eine Fadista mit Seele und Tradition, die die Emotion dessen auf die Bühne bringt, der den Fado von innen lebt. 2021 veröffentlichte sie das Album «À Procura do Fado».\n\nRegelmässig im Fernsehen (RTP) und bei den Fado-Abenden Lissabons zu erleben, darunter im emblematischen Haus Sr. Vinho.",
        },
        "daniel-pinto-coelho": {
            role: "Fadista",
            bio: "Geboren in Valongo, stand er mit 4 Jahren zum ersten Mal auf der Bühne und studierte an der London Music School, bevor er sich 2014 dem Fado verschrieb.\n\nEr gehört zum Ensemble des emblematischen Fado-Hauses Sr. Vinho in Lissabon, wo seine elegante Stimme regelmässig zu hören ist.",
        },
        "madalena-gil": {
            role: "Fadista",
            bio: "Geboren in Almeirim, bezauberte sie 2021 das Land bei The Voice Kids Portugal mit dem Fado «Ser Fadista».\n\nEine junge Stimme mit alter Seele, die verspricht, den Fado — und den Namen Portugals — noch weiter zu tragen.",
        },
    },
};
